module.exports = __webpack_public_path__ + "img/loader.30305c31.svg";